/**
 * Hook to check if user can perform an action on a doctype/document
 * Uses backend permission API as source of truth
 */

import { useQuery } from "@tanstack/react-query";
import { getERPClient } from "@/lib/erp/client";

export type PermissionAction = 
  | "read" 
  | "write" 
  | "print" 
  | "delete" 
  | "submit" 
  | "cancel" 
  | "amend";

export function useCan(
  doctype: string,
  action: PermissionAction,
  name?: string
): boolean {
  const { data } = useQuery({
    queryKey: ["permission", doctype, action, name],
    queryFn: async () => {
      const client = getERPClient();
      const res = await client.call<{ allowed: boolean }>(
        "zaviago_backend.api.permissions.can",
        { doctype, action, name }
      );
      return res;
    },
    // Cache permissions for 5 minutes (eventually-consistent is OK)
    staleTime: 5 * 60 * 1000,
    // Don't refetch on window focus for permissions (reduce noise)
    refetchOnWindowFocus: false,
    // Only fetch if we have required params
    enabled: !!doctype && !!action,
  });

  // Default to false if no data (fail-safe)
  return data?.allowed ?? false;
}














